// A line the screen wants you to read: plain is a card, soft is a honey tint,
// warn is warm. Never red, because nothing in the app punishes.
import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';
import { cx } from './cx';

export interface BannerProps {
  tone?: 'plain' | 'soft' | 'warn';
  icon?: IconName;
  /** A button at the end, if the line asks for something. */
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Banner({ tone = 'plain', icon, action, className, children }: BannerProps) {
  return (
    <div className={cx('banner', tone !== 'plain' && tone, className)} role={tone === 'warn' ? 'status' : undefined}>
      {icon && <span className="banner-ico"><Icon name={icon} /></span>}
      <div className="banner-body">{children}</div>
      {action}
    </div>
  );
}
